/**
 * https://alpinejs.dev/globals/alpine-data#registering-from-a-bundle
 * Logic for the addToCart button and variant select(?)
 */

import { updateMiniCartItemCount } from "../sections/header";
import { openMinicart } from "../sections/mini-cart";
import { notification } from "../sections/notification";
import { setPreorderOnCartLevel } from "../helpers";
import { getOmnibusPriceFromAPI, renderOmnibusPriceFromAPI } from '../vendor/omnibus.js';

/**
 * initialVariantId = when we land on the page (needed for the backInStockTrigger)
 * initialVariantId
 * currentVariantAvailable = needed for backInStock trigger (need to know availability of the current variant even if nothing is selected)
 */
export default ({
  initialVariantId,
  selectedVariantId,
  productVariants,
  productUrl,
  isPreorder
}) => ({
  selectedVariantId: selectedVariantId,
  productVariants: productVariants,
  currentVariantAvailable: false,
  productUrl: productUrl,
  isPreorder: isPreorder,

  init() {
    if (selectedVariantId) {
      this.backInStockTrigger(selectedVariantId);
    } else {
      this.backInStockTrigger(initialVariantId);
    }
  },

  /**
   * @param {{ preventDefault: () => void; }} e
   */
  async addItemToCart(e) {
    e.preventDefault();
    if (!this.selectedVariantId) {
      return;
    }

    const newItem = {
      id: this.selectedVariantId,
      quantity: 1,
    }

    // Casting isPreorder to boolean
    const isPreorder = this.isPreorder === 'true';

    if (isPreorder) {
      newItem['properties'] = {
        _is_preorder: this.isPreorder
      }
    }

    let data;
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            { ...newItem },
          ],
        }),
      });
      data = await response.json();

      const preorderAlreadySet = data.attributes && !!data.attributes['_is_preorder'];

      if (isPreorder && !preorderAlreadySet) {
        await setPreorderOnCartLevel(true);
      }
    } catch (e) {
      console.log("Error", e.message);
    }
    // TODO:
    /**
     * https://dmitripavlutin.com/javascript-fetch-async-await/
     * response.ok property lets you separate good from bad HTTP response statuses.
     * if the response has status 200-299 response.ok returns 'true'
     * if there's a bad HTTP status (outside of the range 200-299) response.ok returns 'false'
     * so you can throw an error manually
     *
     * Then: fetch() rejects only if a request cannot be made or a response cannot be retrieved
     * fetch() will not return error for 404
     * */
    if (typeof data !== "object") return;

    if ("items" in data) {
      // Success!
      if (window.innerWidth > 640) {
        openMinicart();
      } else {
        notification().show("success", "Added to bag");
      }
      updateMiniCartItemCount();
    } else if ("description" in data) {
      // Error!
      console.error(
        typeof data.description === "string"
          ? data.description
          : "Something went wrong"
      );
      notification().show(
        "error",
        typeof data.description === "string"
          ? data.description
          : "Something went wrong"
      );
    }
  },

  updateProductUrl(variantId) {
    if (!variantId) return;
    window.history.replaceState({}, "", `?variant=${variantId}`);

    // Need to refresh the data when the variant is changed.
    // so the liquid object product.selected_or_first_available_variant gets updated too
    // Option one: https://community.shopify.com/c/shopify-design/need-a-page-refresh-everytime-a-variant-changes-to-get-the/td-p/581219
    //window.location.reload();
  },

  /**
   *
   * @param {String} variantId
   * @returns
   */
  updateCurrentVariant(variantId, variantPrice, hasPromo , compareAtPrice) {
    if (!variantId || !variantPrice) return;
    
    let automationTestSpecialPriceSelector = '[data-product-special-price]';
    let automationTestBasePriceSelector = '[data-product-base-price]';
    this.selectedVariantId = variantId;
    this.updateProductUrl(this.selectedVariantId);
    this.backInStockTrigger(variantId);

    let basePriceValue, specialPriceValue;

    if(typeof(compareAtPrice) != 'undefined') {
      specialPriceValue = Math.floor(variantPrice / 100);
      basePriceValue = Math.floor(compareAtPrice / 100);
    }else {
      specialPriceValue = '';
      basePriceValue = Math.floor(variantPrice / 100);
    }

    document
    .querySelectorAll(automationTestSpecialPriceSelector)
    .forEach((priceTag) => {
      priceTag.setAttribute('data-product-special-price', specialPriceValue);
    });

    document
    .querySelectorAll(automationTestBasePriceSelector)
    .forEach((priceTag) => {
      priceTag.setAttribute('data-product-base-price', basePriceValue);
    });

    const renderOmnibusPrice = async (variantID, variantPrice) => {
      const brand = document.getElementById('omnibusprice').dataset.omnibus_brand;
      if (!brand) return;
      renderOmnibusPriceFromAPI(brand, await getOmnibusPriceFromAPI(brand, variantID), variantPrice, hasPromo);
    };
    renderOmnibusPrice(variantId, variantPrice);
  },



  /**
   *
   * @param {String} variantId
   * @returns
   */
  getCurrentVariant(variantId) {
    if (!variantId) return "";
    this.currentVariant = variantId;
    this.makeCurrentVariantChecked(variantId);
    this.backInStockTrigger(variantId);
    return variantId;
  },
  /**
   *
   * @param {String} variantId
   */
  makeCurrentVariantChecked(variantId) {
    const checkbox = document.getElementById(`variant-${variantId}`);
    if (checkbox) {
      // @ts-ignore
      checkbox.checked = "true";
    } else {
      return;
    }
  },

  // TODO: if you do location reload on variant change you don't need this
  backInStockTrigger(variantId) {
    const productVariants = this.productVariants;
    const variantData = productVariants.find(
      (variant) => variant.id == variantId
    );

    this.currentVariantAvailable = variantData.available;
    const backInStockTrigger = document.getElementById("klaviyo_bis_trigger");
    if (backInStockTrigger && variantId && variantData.available) {
      backInStockTrigger.style.display = "none";
    } else {

      if (!backInStockTrigger) return; // Hot Fix
      backInStockTrigger.style.display = "flex";
      backInStockTrigger.setAttribute("data-variant-id", variantId);
    }
  },

  changeButtonText(isAvailable) {
    /*     if (!isAvailable) {
      let currentlyActiveButton;
      if (this.currentVariantAvailable) {
        currentlyActiveButton = this.$root.querySelector("#submitButton");
      } else {
        currentlyActiveButton = this.$root.querySelector("#BIS_trigger");
      }
      if (currentlyActiveButton) {
        currentlyActiveButton.style.color = "gray";
        currentlyActiveButton.textContent = "Notify me when back in stock";

      }
    } */
  },
  setButtonTextToDefault() {
    /*   let currentlyActiveButton;
    let defaultText;
    if (this.currentVariantAvailable) {
      currentlyActiveButton = this.$root.querySelector("#submitButton");
      defaultText = "Add to bag";
    } else {
      currentlyActiveButton = this.$root.querySelector("#BIS_trigger");
      defaultText = "Notify me when back in stock";
    }
    if (currentlyActiveButton) {
      currentlyActiveButton.textContent = defaultText;
      currentlyActiveButton.style.color = "black";
    } */
  },
});
